import React from 'react';
import {
  Box,
  Container,
  Typography,
  Divider,
} from '@mui/material';
import { motion } from 'framer-motion';
import { COMPANY_INFO } from '../utils/constants';

const LegalNoticePage: React.FC = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: 'background.default' }}>
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 4, textAlign: 'center' }}>
            Mentions Légales
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
              1. Informations sur l'éditeur
            </Typography>
            <Typography variant="body1" paragraph>
              Le site web <strong>eztech-solutions.fr</strong> est édité par :
            </Typography>
            <Typography variant="body1" paragraph>
              <strong>EZTECH SOLUTIONS</strong><br />
              Société à Responsabilité Limitée (SARL)<br />
              SIREN : {COMPANY_INFO.siren}<br />
              SIRET : {COMPANY_INFO.siret}<br />
              RCS Nanterre
            </Typography>
            <Typography variant="body1" paragraph>
              <strong>Siège social :</strong><br />
              {COMPANY_INFO.address.street}<br />
              {COMPANY_INFO.address.postalCode} {COMPANY_INFO.address.city}<br />
              France
            </Typography>
            <Typography variant="body1" paragraph>
              <strong>Directeur de la publication :</strong> Zakaria EL GHARMAOUI<br />
              <strong>Contact :</strong> contact@eztech-solutions.fr
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
              2. Hébergement
            </Typography>
            <Typography variant="body1" paragraph>
              Ce site est hébergé par OVH SAS, 2 rue Kellermann, 59100 Roubaix, France.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
              3. Propriété intellectuelle
            </Typography>
            <Typography variant="body1" paragraph>
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, etc.) est protégé par les droits d'auteur et appartient à EZTECH SOLUTIONS ou à ses partenaires.
            </Typography>
            <Typography variant="body1" paragraph>
              Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l'accord écrit préalable d'EZTECH SOLUTIONS.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
              4. Responsabilité
            </Typography>
            <Typography variant="body1" paragraph>
              EZTECH SOLUTIONS s'efforce de fournir sur le site des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
            </Typography>
            <Typography variant="body1" paragraph>
              Tous les informations indiquées sur le site sont données à titre indicatif, et sont susceptibles d'évoluer. Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
              5. Liens hypertextes
            </Typography>
            <Typography variant="body1" paragraph>
              Le site peut contenir des liens hypertextes vers d'autres sites présents sur le réseau Internet. Les liens vers ces autres ressources vous font quitter le site.
            </Typography>
            <Typography variant="body1" paragraph>
              Il est possible qu'à partir de ces pages, il existe des liens vers d'autres sites. EZTECH SOLUTIONS ne pourra être tenue responsable si le contenu de ces sites contrevient aux dispositions légales et réglementaires en vigueur.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
              6. Données personnelles
            </Typography>
            <Typography variant="body1" paragraph>
              Les informations recueillies sur ce site sont enregistrées dans un fichier informatisé par EZTECH SOLUTIONS pour la gestion des demandes de contact et de devis.
            </Typography>
            <Typography variant="body1" paragraph>
              La base légale du traitement est l'intérêt légitime. Les données collectées seront communiquées aux seuls destinataires suivants : EZTECH SOLUTIONS.
            </Typography>
            <Typography variant="body1" paragraph>
              Les données sont conservées pendant une durée de 3 ans maximum. Conformément au règlement européen 2016/679 (RGPD), vous pouvez exercer votre droit d'accès aux données vous concernant et demander leur rectification ou leur effacement en contactant : contact@eztech-solutions.fr
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
              7. Droit applicable et juridiction compétente
            </Typography>
            <Typography variant="body1" paragraph>
              Tout litige en relation avec l'utilisation du site eztech-solutions.fr est soumis au droit français. Il est fait attribution exclusive de juridiction aux tribunaux compétents de Paris.
            </Typography>
          </Box>

          <Box sx={{ mt: 6, p: 3, backgroundColor: 'grey.100', borderRadius: 2 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default LegalNoticePage;